import createSaga from "../../../lib/importer/create-saga";

export default createSaga(
  "CONTACTS",
  "import-contacts",
  "GET_CONTACTS",
  "/contacts"
);
